import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "@ui/wrapper";
import SectionTitle from "@ui/section-title";
import SwiperSlider, { SwiperSlide } from "@ui/swiper";
import Anchor from "@ui/anchor";
import Image from "@ui/image";
import { SectionTitleType, ItemType } from "@utils/types";
import {
    SectionWrap,
    ContentBox,
    ContentBoxTitle,
    ContentBoxText,
    ContentBoxImage,
    StyleHeading,
} from "./style";

const ContentBoxArea = ({ data, hash }) => {
    const mydiv = useRef(null);
    useEffect(() => {
        const h = window.outerHeight - window.innerHeight;
        switch (hash) {
            case "#private-cloud-deployment":
                if (window.document.documentElement.scrollTop == 0) {
                    window.scrollTo({
                        top:
                            mydiv.current.childNodes[0].getBoundingClientRect()
                                .top -
                            76 -
                            h,
                        behavior: "smooth",
                    });
                } else {
                    const he =
                        window.document.documentElement.scrollTop +
                        mydiv.current.childNodes[0].getBoundingClientRect().top;
                    window.scrollTo({ top: he - h, behavior: "smooth" });
                }
                break;
            case "#on-prem-deployment":
                if (window.document.documentElement.scrollTop == 0) {
                    window.scrollTo({
                        top:
                            mydiv.current.childNodes[1].getBoundingClientRect()
                                .top -
                            76 -
                            h,
                        behavior: "smooth",
                    });
                } else {
                    const he =
                        window.document.documentElement.scrollTop +
                        mydiv.current.childNodes[1].getBoundingClientRect().top;
                    window.scrollTo({ top: he - h, behavior: "smooth" });
                }
                break;
            case "#data-analytics":
                if (window.document.documentElement.scrollTop == 0) {
                    window.scrollTo({
                        top:
                            mydiv.current.childNodes[2].getBoundingClientRect()
                                .top -
                            76 -
                            h,
                        behavior: "smooth",
                    });
                } else {
                    const he =
                        window.document.documentElement.scrollTop +
                        mydiv.current.childNodes[2].getBoundingClientRect().top;
                    window.scrollTo({ top: he - h, behavior: "smooth" });
                }
                break;
            case "#modeling-service":
                if (window.document.documentElement.scrollTop == 0) {
                    window.scrollTo({
                        top:
                            mydiv.current.childNodes[3].getBoundingClientRect()
                                .top -
                            76 -
                            h,
                        behavior: "smooth",
                    });
                } else {
                    const he =
                        window.document.documentElement.scrollTop +
                        mydiv.current.childNodes[3].getBoundingClientRect().top;
                    window.scrollTo({ top: he - h, behavior: "smooth" });
                }
                break;
        }
    });
    return (
        <SectionWrap>
            <div ref={mydiv}>
                {data.items.map((it, idx) => (
                    <ContentBox>
                        <Container>
                            <ContentBoxTitle>{it.title}</ContentBoxTitle>
                            <Row>
                                <Col
                                    lg={{ span: 6, order: 1 }}
                                    xs={{ span: 12, order: 1 }}
                                >
                                    <ContentBoxText>
                                        {it.description}
                                    </ContentBoxText>
                                </Col>
                                <Col
                                    lg={{ span: 6, order: 2 }}
                                    xs={{ span: 12, order: 2 }}
                                >
                                    {it?.images[0]?.src && (
                                        <Image
                                            src={it.images[0].src}
                                            alt={it.images[0].alt || it.title}
                                        />
                                    )}
                                </Col>
                            </Row>
                        </Container>
                    </ContentBox>
                ))}
            </div>
        </SectionWrap>
    );
};

ContentBoxArea.propTypes = {
    data: PropTypes.shape({
        section_title: PropTypes.shape(SectionTitleType),
        items: PropTypes.arrayOf(PropTypes.shape(ItemType)),
    }),
    hash: PropTypes.string,
};

export default ContentBoxArea;

// {data?.section_title && (
//     <SectionTitle
//         mb={["47px", null, "60px"]}
//         title={data.section_title?.title}
//         subtitle={data.section_title?.subtitle}
//     />
// )}

// <ContentBoxImage>
//     {data?.images[0].src && (<Image src = {data?.images[0].src} alt = {data?.images[0].alt}/>)}
// </ContentBoxImage>

//     <ContentBox>
//     {data?.items.map((it,idx) => (<div key = {idx}>

//         <ContentBoxText>{it.description}</ContentBoxText>
//     </div>))}
// </ContentBox>
